import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";
import { useContext, useState } from "react";
import { SocketContext } from "../../context/socket";
import propagandaPlayer from "../../assets/propaganda-player.svg";
import vipImg from "../../assets/vip.svg";
import hoursglass from "../../assets/Hoursglass.svg";

export function Waiting() {
  const { t } = useTranslation();
  const code = useSelector((state: RootState) => state.player.code);
  const vip = useSelector((state: RootState) => state.player.vip);
  const name = useSelector((state: RootState) => state.player.playerName);
  const gameState = useSelector((state: RootState) => state.player.gameState);
  const playersNumber = useSelector(
    (state: RootState) => state.player.playersNumber
  );
  const [hide, setHide] = useState(false);
  const socket = useContext(SocketContext);
  const playerImageAlt = "player image";
  const hourglassImageAlt = "hourglass";

  const startGame = () => {
    setHide(true);
    socket.emit("QUESTIONS", { roomId: code, name: name });
  };

  return (
    <div
      id="waiting"
      className="player-game-min relative z-0 w-screen overflow-x-hidden overflow-y-auto bg-join-background bg-cover"
    >
      <div className="player-game-min pointer-events-none absolute inset-0 z-10 bg-orange opacity-40" />
      {vip && gameState === "lobby" && (
        <div className="relative z-30 flex w-full flex-col items-center px-4 py-4 player-game-safe-y">
          <img
            alt={playerImageAlt}
            className="z-30 mt-2 h-20 w-auto shrink object-contain xs:h-24 desktop:mt-8 desktop:h-44"
            src={propagandaPlayer}
          />
          <img
            alt={hourglassImageAlt}
            className="z-30 mt-6 h-16 w-auto shrink xs:h-20 desktop:mt-12 desktop:h-40"
            src={vipImg}
          />
          <h3 className="z-30 mt-6 w-[92%] max-w-xl text-center font-Inter text-2xl text-darker-blue xs:text-3xl phone:text-3xl desktop:mt-10 desktop:text-8xl">
            {t("join.ready")}
          </h3>
          {!hide && (
            <button
              className="z-30 mt-6 h-28 w-28 shrink-0 rounded-full border-2 border-dark-blue bg-btn-red font-Cairo text-3xl text-darker-blue disabled:opacity-50 desktop:mt-10 desktop:h-56 desktop:w-56 desktop:text-5xl"
              disabled={playersNumber < 2}
              onClick={startGame}
            >
              {t("join.start")}
            </button>
          )}
        </div>
      )}
      {!vip && (
        <div className="relative z-30 flex w-full flex-col items-center px-4 py-4 player-game-safe-y">
          <img
            alt={playerImageAlt}
            className="z-30 mt-2 h-20 w-auto shrink object-contain xs:h-24 desktop:mt-8 desktop:h-44"
            src={propagandaPlayer}
          />
          <img
            alt={hourglassImageAlt}
            className="z-30 mt-6 h-16 w-auto shrink xs:h-20 desktop:mt-12 desktop:h-40"
            src={hoursglass}
          />
          <h3 className="z-30 mt-6 w-[92%] max-w-xl text-center font-Inter text-2xl text-darker-blue xs:text-3xl phone:text-3xl desktop:mt-10 desktop:text-8xl">
            {t("join.about_to_start")}
          </h3>
        </div>
      )}
    </div>
  );
}
